
export enum QualityId {
    Corrected = -3,
    Missing = -2,
    Bad = -1,
    Available = 0,
    Flat = 1,
    Scatter = 2,
    OutOfRange = 3,
    Invalid = 4,
    Suspicious = 5,
    CriticalHigh = 6,
    WarningHigh = 7,
    InformationHigh = 8,
    InformationLow = 9,
    WarningLow = 10,
    CriticalLow = 11,
    InformationInRange = 12,
    WarningInRange = 13,
    CriticalInRange = 14
}
